export default "__VITE_ASSET__DhTUihg8__"